import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { FaUserAlt, FaShoppingCart } from 'react-icons/fa';
import { AiFillDatabase } from 'react-icons/ai';
import { FaSync } from 'react-icons/fa';
import { IoIosNotifications } from 'react-icons/io';
import { HiMenu } from 'react-icons/hi';
import { BsFillInboxFill } from 'react-icons/bs';
import { RiLockPasswordLine } from 'react-icons/ri';
import { IoMdNotifications } from 'react-icons/io';
import { VscGraph } from 'react-icons/vsc';

import api from '~/services/api';

import { useAuth } from '~/hooks/authentication';
import { useNotifications } from '~/hooks/notifications';
import { useConnection } from '~/hooks/connection';

import logoImg from '~/assets/logo.png';
import lologoClienteImg from '~/assets/cliente.png';

import Submenu from '../Submenu';
import Loading from '../Loading';

import {
  Container,
  Mobile,
  Content,
  Header,
  Connection,
  LogoClient,
  Ic,
  Information,
  Opts,
  Opt,
  Footer,
  NotificationCount,
} from './styles';

const Menu: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const { status: connectionStatus } = useConnection();

  const { data: userInfo, signOut } = useAuth();
  const { total } = useNotifications();

  const [inSyncPedidos, setInSyncPedidos] = useState(false);
  const [inSyncFaturamento, setInSyncFaturamento] = useState(false);

  const [inSyncProdutos, setInSyncProdutos] = useState(false);
  const [inSyncEstoques, setInSyncEstoques] = useState(false);
  const [inSyncPrecos, setInSyncPrecos] = useState(false);

  const [mobileMenuStatus, setMobileMenuStatus] = useState(false);

  const handlerMobileMenuVisibility = () => {
    setMobileMenuStatus(!mobileMenuStatus);
  };

  const handlerCheckPage = (page: string): boolean => {
    const data = location.pathname.split('/');
    return data[1] === page ? true : false;
  };

  const handlerChangePage = (page: string): void => {
    history.push(`${page}`);
    setMobileMenuStatus(false);
  };

  const goToAllNotifications = () => {
    history.push(`avisos`);
  };

  const syncPedidos = async () => {
    try {
      setInSyncPedidos(true);

      const response = await api.get(`sync-pedidos`);

      const { data } = response;

      if (data && data.error) {
        toast.error(data.message);
      } else {
        toast.success(data.message);
      }

      setInSyncPedidos(false);
    } catch (e) {
      setInSyncPedidos(false);
    }
  };

  const syncFaturamento = async () => {
    try {
      setInSyncFaturamento(true);

      const response = await api.get(`sync-faturamento`);

      const { data } = response;

      if (data && data.error) {
        toast.error(data.message);
      } else {
        toast.success(data.message);
      }

      setInSyncFaturamento(false);
    } catch (e) {
      setInSyncFaturamento(false);
    }
  };

  const syncProdutos = async () => {
    try {
      setInSyncProdutos(true);

      const response = await api.get(`sync-produtos`);

      const { data } = response;

      if (data && data.error) {
        toast.error(data.message);
      } else {
        toast.success(data.message);
      }

      setInSyncProdutos(false);
    } catch (e) {
      setInSyncProdutos(false);
    }
  };

  const syncPrecos = async () => {
    try {
      setInSyncPrecos(true);

      const response = await api.get(`sync-precos`);

      const { data } = response;

      if (data && data.error) {
        toast.error(data.message);
      } else {
        toast.success(data.message);
      }

      setInSyncPrecos(false);
    } catch (e) {
      setInSyncPrecos(false);
    }
  };

  const syncEstoques = async () => {
    try {
      setInSyncEstoques(true);

      const response = await api.get(`sync-estoques`);

      const { data } = response;

      if (data && data.error) {
        toast.error(data.message);
      } else {
        toast.success(data.message);
      }

      setInSyncEstoques(false);
    } catch (e) {
      setInSyncEstoques(false);
    }
  };

  return (
    <Container>
      <Mobile>
        <div>
          <img
            src={lologoClienteImg}
            alt="Commerceplus"
            title="2.3"
            height={'20px'}
          />
        </div>
        <button type="button">
          <HiMenu
            size={32}
            color="#fff"
            onClick={handlerMobileMenuVisibility}
          />
        </button>
      </Mobile>
      <Content
        className={mobileMenuStatus ? 'menu-mobile-show' : 'menu-mobile-hide'}
      >
        <LogoClient>
          <img src={lologoClienteImg} alt="" />
        </LogoClient>

        <Header>
          <Ic>
            <FaUserAlt size={22} color="#333" />
          </Ic>

          <Information>
            <h1>{userInfo.nome}</h1>
            <p>{userInfo.email}</p>
            <button type="button" onClick={signOut}>
              Sair
            </button>
          </Information>

          <NotificationCount onClick={goToAllNotifications}>
            <IoIosNotifications size={32} color={total ? '#fff' : '#ccc'} />
            <strong>{total}</strong>
          </NotificationCount>
        </Header>

        <Connection className={connectionStatus ? 'online' : 'offline'}>
          <main>
            <i>
              <AiFillDatabase size={26} color="#fff" />
            </i>
            <div>
              <h1>TOTVS (ORACLE)</h1>
              <h2>{connectionStatus ? 'Conectado!' : 'Desconectado!'}</h2>
            </div>
          </main>
        </Connection>

        <Opts>
          <Opt
            active={handlerCheckPage(`dashboard`)}
            onClick={() => handlerChangePage(`/dashboard`)}
          >
            <i>
              <VscGraph
                size={20}
                color={handlerCheckPage(`dashboard`) ? '#fff' : '#fff'}
              />
            </i>
            <span>Dashboard</span>
          </Opt>

          <Submenu title="Pedidos">
            <>
              <Opt
                active={
                  handlerCheckPage(`pedidos`) || handlerCheckPage(`pedido`)
                }
                onClick={() => handlerChangePage(`/pedidos`)}
              >
                <i>
                  <FaShoppingCart
                    size={20}
                    color={
                      handlerCheckPage(`pedidos`) || handlerCheckPage(`pedido`)
                        ? '#fff'
                        : '#fff'
                    }
                  />
                </i>
                <span>Meus Pedidos</span>
              </Opt>

              <Opt onClick={syncPedidos} disabled={inSyncPedidos}>
                <i>
                  {inSyncPedidos ? (
                    <Loading size={16} color="#fff" />
                  ) : (
                    <FaSync size={16} color={'#fff'} />
                  )}
                </i>
                <span>+ Sync Pedidos</span>
              </Opt>

              <Opt onClick={syncFaturamento}>
                <i>
                  {inSyncFaturamento ? (
                    <Loading size={16} color="#fff" />
                  ) : (
                    <FaSync size={16} color={'#fff'} />
                  )}
                </i>
                <span>+ Sync Faturamento</span>
              </Opt>
            </>
          </Submenu>

          <Submenu title="Produtos">
            <>
              <Opt
                active={
                  handlerCheckPage(`produtos`) || handlerCheckPage(`produto`)
                }
                onClick={() => handlerChangePage(`/produtos`)}
              >
                <i>
                  <BsFillInboxFill
                    size={20}
                    color={
                      handlerCheckPage(`produtos`) ||
                      handlerCheckPage(`produto`)
                        ? '#fff'
                        : '#fff'
                    }
                  />
                </i>
                <span>Produtos</span>
              </Opt>

              <Opt onClick={syncProdutos}>
                <i>
                  {inSyncProdutos ? (
                    <Loading size={16} color="#fff" />
                  ) : (
                    <FaSync size={16} color={'#fff'} />
                  )}
                </i>
                <span>+ Sync Produtos</span>
              </Opt>

              <Opt onClick={syncPrecos}>
                <i>
                  {inSyncPrecos ? (
                    <Loading size={16} color="#fff" />
                  ) : (
                    <FaSync size={16} color={'#fff'} />
                  )}
                </i>
                <span>+ Sync Preços</span>
              </Opt>

              <Opt onClick={syncEstoques}>
                <i>
                  {inSyncEstoques ? (
                    <Loading size={16} color="#fff" />
                  ) : (
                    <FaSync size={16} color={'#fff'} />
                  )}
                </i>
                <span>+ Sync Estoques</span>
              </Opt>
            </>
          </Submenu>

          <Submenu title="Configurações">
            <>
              <Opt
                active={handlerCheckPage(`avisos`)}
                onClick={() => handlerChangePage(`/avisos`)}
              >
                <i>
                  <IoMdNotifications
                    size={20}
                    color={handlerCheckPage(`avisos`) ? '#fff' : '#fff'}
                  />
                </i>
                <span>Avisos</span>
              </Opt>

              <Opt
                active={handlerCheckPage(`minha-senha`)}
                onClick={() => handlerChangePage(`/minha-senha`)}
              >
                <i>
                  <RiLockPasswordLine
                    size={20}
                    color={handlerCheckPage(`minha-senha`) ? '#fff' : '#fff'}
                  />
                </i>
                <span>Minha Senha</span>
              </Opt>
            </>
          </Submenu>
        </Opts>

        <Footer>
          <img src={logoImg} alt="Commerceplus" title="Commerceplus" />
          <span>Versão: 0.0.1</span>
        </Footer>
      </Content>
    </Container>
  );
};

export default Menu;
